import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import loginhero from "../../assets/image/login-hero.svg"
import LoginModal from "./LoginModal";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { reset } from '../../features/Auth/authSlice';
import toast, { Toaster } from 'react-hot-toast';
import { Container, Form, Google, Hero, Nav, Section } from "../../components/LoginStyles";
import DataService from "../../features/Auth/dataService";


const Login = () => {
	const dataService = DataService();
	const dispatch = useAppDispatch()
	const navigate = useNavigate();

	const { isError, message } = useAppSelector((state: { auth: any; }) => state.auth)

	const [showModal, setShowModal] = useState(false)


	function getToken() {
		try {
			// Attempt to retrieve the token from the dataService object
			const token = dataService && typeof dataService.getToken === 'function' ? dataService.getToken() : null;
			// Return the token if retrieval is successful
			return token;
		} catch (error) {
			// Log any errors that occur during token retrieval
			console.error('Error processing data:', error);
			// Handle the error case by returning null or throwing a custom error
			return null;
		}
	}
	const token = getToken();

	useEffect(() => {
		if (token) {
			navigate('/dashboard')
		}
	}, [token, dispatch, navigate])




	useEffect(() => {
		if (isError) {
			toast.error(message);
		}

		dispatch(reset())
	}, [isError, message, dispatch,])

	const handleLogin = () => {
		setShowModal(true)
	}

	return (
		<Container>
			<Toaster
				position="top-center"
				toastOptions={{
					className: "",
					duration: 5000,
					success: {
						duration: 5000,
					},
				}}
			/>
			<Nav>
				<a href="*">
					<img src="/images/login-logo.svg" alt="" />
				</a>
			</Nav>
			<Section>
				<Hero>
					<h1>Do more faster with Outcess.</h1>
					<img src={loginhero} alt="hero" />
				</Hero>
				<Form>
					<Google onClick={handleLogin}>
						<img src="/images/google.svg" alt="" />
						Sign in your account!
					</Google>
					<LoginModal showModal={showModal} setShowModal={setShowModal} />
				</Form>
			</Section>
		</Container>
	);
}

export default Login;
